import { useTranslation } from "react-i18next";

import Typography from "features/components/Typography";
import { FilterOperator } from "features/ui/Filters/types";
import { areFilterValuesComplete } from "features/ui/Filters/utils";

interface Props {
  operator: FilterOperator | null;
  values: string[] | null;
  className?: string;
}

const IncompleteRangeHint = ({ operator, values, className }: Props) => {
  const { t } = useTranslation();

  if (
    operator !== FilterOperator.BETWEEN ||
    areFilterValuesComplete(operator, values ?? [])
  ) {
    return null;
  }

  return (
    <Typography variant="caption" color="text.secondary" className={className}>
      {t("filters:messages.between_incomplete")}
    </Typography>
  );
};

export default IncompleteRangeHint;
